import React, { useContext } from "react";
import { AppLayout } from "~/components/Layout/AppLayout";
import { SideNavigation } from "~/components/Layout/SideNavigation";
import { TopNavigation } from "~/components/Layout/TopNavigation";
import { PageFallbackOutlet } from "~/components/Layout/PageFallbackOutlet";
import { RoutePendingUI } from "~/components/Layout/RoutePendingUI";
import { userContext } from "~/context/ContextProvider";
import * as APITypes from "~/API";

/**
 * Active tenants get the full shell (top + side nav).
 * Non-tenants navigate from home search / action cards; routes remain reachable by URL.
 */
export const TenantAppShell: React.FC = () => {
  const { status } = useContext(userContext);
  const showSideNav = status === APITypes.TenantStatusType.Active;

  return (
    <AppLayout
      TopNavigation={<TopNavigation />}
      SideNavigation={showSideNav ? <SideNavigation /> : null}
      PageContent={
        <RoutePendingUI>
          <PageFallbackOutlet />
        </RoutePendingUI>
      }
    />
  );
};
